{
	"title": "{{productName}} ιστορικό συναλλαγών",
	"item": {
		"time": "Χρόνος",
		"description": "Περιγραφή",
		"transactionId": "Αναγνωριστικό συναλλαγής",
		"showIds": "Εμφάνιση IDs",
		"depositTitle": "Διασφάλιση από την DNV, που επιτρέπει μια κατάθεση σε τράπεζα άνθρακα",
		"depositDescription": "Μόλις ο οργανισμός διασφάλισης τρίτου μέρους «DNV» εξασφαλίσει τον αποθηκευμένο όγκο άνθρακα σε ένα ψηφιακό σύστημα Monitor-Report-Verify, γίνεται νέα κατάθεση στην τράπεζα άνθρακα.",
		"withdrawalTitle": "Τιμολόγιο προς προμηθευτή, που προκαλεί ανάληψη από τράπεζα άνθρακα",
		"withdrawalDescription": "Με την τιμολόγηση του υλικού evoZero στον προμηθευτή, έχει πραγματοποιηθεί ανάληψη από την τράπεζα άνθρακα.",
		"transferTitle": "Μεταφορά μειώσεων άνθρακα στον κάτοχο της δήλωσης",
		"transferDescription": "Ο προμηθευτής ξεκίνησε τη μεταφορά των μειώσεων άνθρακα στον κάτοχο της δήλωσης, με βάση τον όγκο υλικού evoZero που εισήχθη στο παραδοθέν προϊόν."
	},
	"proofIdsModal": {
		"titleTransactions": "Προβολή συναλλαγών",
		"titleMeasurements": "Προβολή μετρήσεων",
		"paragraph1": "Ένα βήμα συναλλαγής στο {{productName}} περιλαμβάνει τη συγκέντρωση συναλλαγών στο κατανεμημένο καθολικό. Παρακάτω, θα βρείτε μια λίστα με συνδέσμους προς υπηρεσίες τρίτων όπου μπορείτε να δείτε αυτές τις συναλλαγές.",
		"paragraph2": "Λάβετε υπόψη ότι αυτοί οι σύνδεσμοι θα σας μεταφέρουν σε εξωτερικούς ιστότοπους που παρέχουν δυνατότητες προβολής συναλλαγών.",
		"open": "Άνοιγμα",
		"close": "Κλείσιμο"
	},
	"errors": {
		"fetch": "Δεν ήταν δυνατή η ανάκτηση του ιστορικού δραστηριότητας"
	}
}
